import * as React from "react"

import { cn } from "@/lib/utils"

const getTodayDateInputValue = () => {
  const now = new Date()
  const tzOffsetMs = now.getTimezoneOffset() * 60 * 1000
  return new Date(now.getTime() - tzOffsetMs).toISOString().slice(0, 10)
}

const Input = React.forwardRef(({ className, type, min, ...props }, ref) => {
  const resolvedMin = type === "date" && (!min || String(min).trim() === "")
    ? getTodayDateInputValue()
    : min

  return (
    <input
      type={type}
      min={resolvedMin}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
